export default {
  form: {
    title:
      'Create a Swiftaid account to increase your charitable donations by 25% – at no cost to you!',
    subtext1:
      'Swiftaid helps with Gift Aid by removing the burden of admin from charities and giving donors more control over their Gift Aid contributions.',
    subtext2:
      'Swiftaid uses your information to identify and add Gift Aid to any eligible donations you make during this tax year. {0}',
    subtextLinkText: 'Learn more here',
    subtextLinkHref: 'https://www.swiftaid.co.uk/donor',
    formFields: {
      emailAddress: {
        label: 'Your email',
        placeholder: 'Enter your email',
        updateEmailLinkText: 'Login to update your email',
      },
      firstname: {
        label: 'First name',
        placeholder: 'Enter your first name',
      },
      lastname: {
        label: 'Last name',
        placeholder: 'Enter your last name',
      },
      country: {
        label: 'Country',
        placeholder: 'Select a country',
      },
      postcode: {
        label: 'Postcode',
        placeholder: 'Postcode',
        button: 'Find address',
        noAddressFound: 'No addresses found, please enter it below',
      },
      addressSelect: {
        label: 'Select an address',
        help: 'I cannot find my address in the list',
      },
      addressLine1: {
        label: 'Address line 1',
        placeholder: 'Enter line 1 of your address',
      },
      addressLine2: {
        label: 'Address line 2',
        placeholder: 'Enter line 2 of your address',
      },
      city: {
        label: 'City/Town',
        placeholder: 'Enter your city or town',
      },
      county: {
        label: 'County',
        placeholder: 'Enter your county',
      },
      state: {
        label: 'State/Province/County',
        placeholder: 'Enter your state, province or county',
      },
      zipcode: {
        label: 'Zip/Postal code',
        placeholder: 'Enter your zip or postal code',
      },
      submit: {
        text: 'Create my account',
      },
    },
    authorisationStatement: {
      title: 'Your authorisation',
      paragraph1:
        'I am a UK taxpayer and I understand that if the Gift Aid claimed on donations I make in this tax year is more than the tax I pay on my income and capital gains it will be my responsibility to pay the difference to HMRC.',
      authText:
        'I authorise Swiftaid to Gift Aid all my donations for this tax year including those made previously on which I have not opted to add Gift Aid. I wish this to also apply to the next tax year when this authorisation is given between 1 March and 5 April inclusive.',
      checkboxLabel:
        'I agree with the above statements and have carefully read Swiftaid’s {0} and {1}.',
      termsLinkText: 'Terms',
      termsLinkHref: 'https://streeva.github.io/swiftaid-legal-docs/terms/',
      privacyLinkText: 'Privacy Policy',
      privacyLinkHref:
        'https://streeva.github.io/swiftaid-legal-docs/privacy-policy/',
    },
  },
  reauthForm: {
    title: 'Update your details & renew Swiftaid authorisation',
    subtext1:
      'Please make sure all the details below are correct before you continue.',
    formFields: {
      submit: {
        text: 'Continue',
      },
    },
  },
  genericModal: {
    fetchingContentMessage: 'Fetching content...',
    viewInNewWindow: 'View in a new window',
    closeModal: 'Close',
  },
  termsModal: {
    header: 'Terms & Conditions',
  },
  privacyModal: {
    header: 'Privacy Policy',
  },
  footer: {
    text: 'Streeva Ltd ("Swiftaid") registered in England & Wales. Company No.09451226',
  },
  result: {
    title: 'Please check your email to continue',
    lead: ({ named }: { named: any }) => {
      const email = named('email')
      return email
        ? `We have sent an email to ${email} to confirm your email address.`
        : 'We have sent an email to confirm your email address.'
    },
    help: "Can't find the email? Please double check you are using the correct email and make sure to check your junk or spam folder.",
  },
  confirm: {
    success: {
      title: 'Thank you!',
      para1:
        'Charities can now collect Gift Aid on your donations using Swiftaid.',
      para2:
        'A welcome email has been sent to you containing helpful information and links to manage your Swiftaid account.',
      para3: 'Thank you for making more of a difference!',
      link: 'Learn more about Swiftaid',
    },
    failure: {
      title: 'Whoops!',
      errorMessage:
        'Sorry we could not create your Swiftaid account because the confirmation link we sent you expired.',
      link: 'Please click here to start again',
    },
  },
  reauthConfirm: {
    success: {
      para1:
        'Charities can continue to collect Gift Aid on your donations using Swiftaid.',
    },
  },
}
